import { Component, OnDestroy, OnInit } from '@angular/core';
import { TableColumn } from '@shared/interface/table.interface';
import { getDistributorTableColumns } from '../../../distributor.data';
import { BehaviorSubject } from 'rxjs';
import { UtilitiesService } from '@services/utilities.service';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { DistributorService } from '../../../distributor.service';
import { API } from '@config/constants/api.constant';

@Component({
  selector: 'app-non-active',
  styleUrls: ['./non-active.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_PENDING_NON_ACTIVATED"
      [tableColumns]="tableColumns"
      [privilegeDetail]="privilegeDetailPending"
      [actionPathDetail]="distributorService.BasePathDistributorDetail + '/pending/non-active/'"
      (totalCount)="onTotalCount($event)"
    />
  `,
})
export class NonActiveComponent implements OnInit, OnDestroy {
  tableColumns: TableColumn[] = getDistributorTableColumns('pending');
  privilegeDetailPending: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public static totalCount = new BehaviorSubject(0);

  constructor(public utilities: UtilitiesService, private rolePrivilegeService: RolePrivilegeService, public distributorService: DistributorService) {}

  ngOnInit() {
    this.privilegeDetailPending.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_MENUNGGU', 'TAB_LIST_REGISTRATION_REQUEST', 'CTA_VIEW_DETAIL'));
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilegeDetailPending.value, this.tableColumns);
  }

  onTotalCount = (e: number) => NonActiveComponent.totalCount.next(e);

  ngOnDestroy() {}

  protected readonly API = API;
}
